import React from "react"

export default function PersonalPlanning() {
  return (
    <symbol id="svg-personalplanning" viewBox="0 0 36 36">
      <path
        d="M18 15C21 15 22.5 18.63 20.385 20.76C18.255 22.89 14.625 21.375 14.625 18.375C14.625 16.5 16.125 15 18 15ZM24.75 28.5H11.25V26.82C11.25 24.945 14.25 23.445 18 23.445C21.75 23.445 24.75 24.945 24.75 26.82V28.5ZM28.5 30H7.5V13.5H28.5V30ZM24 3V6H12V3H9V6H7.5C6.70435 6 5.94129 6.31607 5.37868 6.87868C4.81607 7.44129 4.5 8.20435 4.5 9V30C4.5 30.7956 4.81607 31.5587 5.37868 32.1213C5.94129 32.6839 6.70435 33 7.5 33H28.5C29.2956 33 30.0587 32.6839 30.6213 32.1213C31.1839 31.5587 31.5 30.7956 31.5 30V9C31.5 8.20435 31.1839 7.44129 30.6213 6.87868C30.0587 6.31607 29.2956 6 28.5 6H27V3H24Z"
        fill="currentColor"
      />
    </symbol>
  )
}
